import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PanelHeaderTemplate from '../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import { useRequestTypeMapping } from '../../Hooks/Features/HelpDesk/useRequestTypeMapping';
import { AgGridReact } from '@ag-grid-community/react';
import { SkeletonDataTable } from '../Loader/Loader';
import CommanDialog from '../CommonCompo/CommanDialog/CommanDialog';
import _ from "underscore"


const RequestTypeMapping = ({ visible, onHide, options }) => {
    const { handleAddrequestType, requestTypeMapping, setRequestTypeMapping, columnDefs, mappingList, loader, getRequestTypeUserMappingData, filters, setFilters, HandleDeleteMapping, confirmationPopup, setConfirmationPopup } = useRequestTypeMapping({ onHide });

    return (
        <div>
            <Dialog header="Request Type User Mapping" draggable={false} visible={visible} className='modal-medium' modal onHide={() => { setRequestTypeMapping({}); onHide() }}>
                <div className="row align-items-end" style={{ rowGap: '1rem' }}>
                    <div className="col-md-5 col-12">
                        <label>Request Type *</label>
                        <Dropdown
                            name="requestType"
                            options={_.filter(options?.allType, (item) => item?.parent_request_type_id) || []}
                            value={requestTypeMapping?.requestType}
                            onChange={(e) => setRequestTypeMapping((prev) => ({ ...prev, requestType: e.target.value }))}
                            placeholder="Select"
                            className="input-dd"
                            optionLabel="request_type_name"
                            filter filterInputAutoFocus
                        />
                    </div>
                    <div className="col-md-5 col-12">
                        <label>User *</label>
                        <MultiSelect
                            name="Users"
                            options={options?.users}
                            value={requestTypeMapping?.users}
                            onChange={(e) => setRequestTypeMapping((prev) => ({ ...prev, users: e.target.value }))}
                            placeholder="Select"
                            className="input-dd"
                            optionLabel="user_display_name"
                            filter filterInputAutoFocus style={{ width: "100%" }}
                            panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'Users', requestTypeMapping.users, () => setRequestTypeMapping((prevState) => ({ ...prevState, users: [] })))}
                        />
                    </div>
                    <div className="col-2" draggable={false} >
                        <button
                            className="btn-primary"
                            onClick={handleAddrequestType}>
                            <FontAwesomeIcon icon="fa-solid fa-add" />
                        </button>
                    </div>
                </div>
                <hr></hr>
                <div className='w40'>
                    <MultiSelect
                        value={filters.requestType}
                        options={_.filter(options?.allType, (item) => item?.parent_request_type_id) || []}
                        onChange={e => {
                            setFilters((prev) => ({ ...prev, requestType: e.value, isChange: true }));
                        }}
                        placeholder="Request Type"
                        className="w-100"
                        optionLabel="request_type_name"
                        onHide={() => filters?.isChange && getRequestTypeUserMappingData()}
                        panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'requestType', filters.requestType, () => setFilters((prevState) => ({ ...prevState, requestType: [], isChange: true })))}
                    />
                </div>
                {
                    loader ? <SkeletonDataTable numSkeletons={10} /> : <div className="ag-theme-alpine my-2" style={{ height: "50vh", width: '100%' }}>
                        <AgGridReact
                            rowData={mappingList}
                            columnDefs={columnDefs}
                            rowHeight={40}
                            headerHeight={30}
                        />
                    </div>
                }
            </Dialog>
            <CommanDialog visible={confirmationPopup?.show} handleClose={() => setConfirmationPopup({ show: false, id: "" })} handleFun={HandleDeleteMapping} message="Are you sure you want to delete this mapping?" />
        </div>
    )
}

export default RequestTypeMapping